export const routes = [
  {
    path: '/eixo',
    component: () => import(/* webpackChunkName: "axis" */ './components/List'),
    name: 'axis.list',
    meta: {
      requiresAuth: true
    }
  }
]
